module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout Group',
          to: {
            path: '/tryout-groups'
          }
        },
        {
          text: 'Tambah Tryout Group'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Tryout Group" : "Ubah Tryout Group") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {}
  }, [_c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold dark--text",
    attrs: {
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                            Upload *\n                        ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Ukuran gambar 400 x 500\n                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Maximum size is 300 KB\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Judul *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "tryout_group_judul",
      "placeholder": "Judul Tryout",
      "outlined": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Deskripsi *\n                                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "id": "tryout_group_deskripsi",
      "placeholder": "Deskripsi Tryout",
      "outlined": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Kelas *\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "tryout_group_kelas",
      "outlined": "",
      "placeholder": "Pilih Kelas",
      "items": [{
          text: '1 (SD)',
          value: 1
        },
        {
          text: '2 (SD)',
          value: 2
        },
        {
          text: '3 (SD)',
          value: 3
        },
        {
          text: '4 (SD)',
          value: 4
        },
        {
          text: '5 (SD)',
          value: 5
        },
        {
          text: '6 (SD)',
          value: 6
        },
        {
          text: '7 (SMP)',
          value: 7
        },
        {
          text: '8 (SMP)',
          value: 8
        },
        {
          text: '9 (SMP)',
          value: 9
        },
        {
          text: '10 (SMA)',
          value: 10
        },
        {
          text: '11 (SMA)',
          value: 11
        },
        {
          text: '12 (SMA)',
          value: 12
        } ]
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Tipe *\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "tryout_group_tipe",
      "outlined": "",
      "placeholder": "Pilih Tipe",
      "items": [{
          text: 'SBMPTN',
          value: 'SBMPTN'
        },
        {
          text: 'Ujian Nasional (UN)',
          value: 'UJIAN_AKHIR_NASIONAL',
        },
        {
          text: 'Ujian Akhir Sekolah (UAS)',
          value: 'UJIAN_AKHIR_SEKOLAH',
        },
        {
          text: 'Ujian Sekolah',
          value: 'UJIAN_SEKOLAH',
        } ]
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Kategori *\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "tryout_group_kategori",
      "outlined": "",
      "placeholder": "Pilih Kategori",
      "items": [{
          text: 'BERAGENDA',
          value: 'SCHEDULED',
        },
        {
          text: 'INSTANT',
          value: 'INSTANT_COMPLETE',
        },
        {
          text: 'TPM',
          value: 'TPM',
        } ]
    },
    model: {
      value: (_vm.variant),
      callback: function($$v) {
        _vm.variant = $$v
      },
      expression: "variant"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Pra-Syarat Tryout Serial\n                                ")]), _vm._v(" "), _c('app-tryoutgroupchooser', {
    attrs: {
      "params": {
        grade: _vm.grade,
        status: 'PUBLISHED',
        type: _vm.type,
        variant: _vm.variant,
      },
      "group": _vm.dependencyName
    },
    on: {
      "dblClicked": function($event) {
        return _vm.addDependency($event)
      },
      "clearGroup": _vm.removeDependency
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Opsi\n                                ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 mr-0 ml-2 my-0",
    attrs: {
      "id": "tryout_group_opsi_sticky",
      "label": "Sticky",
      "active-class": "act-radio-btn",
      "outlined": ""
    },
    model: {
      value: (_vm.isSticky),
      callback: function($$v) {
        _vm.isSticky = $$v
      },
      expression: "isSticky"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 mr-0 ml-2 my-0",
    attrs: {
      "id": "tryout_group_opsi_private",
      "label": "Private",
      "active-class": "act-radio-btn",
      "outlined": ""
    },
    model: {
      value: (_vm.isPrivate),
      callback: function($$v) {
        _vm.isPrivate = $$v
      },
      expression: "isPrivate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jenis Tryout ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_free",
      "label": "FREE",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_premium",
      "label": "PREMIUM",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_partner",
      "label": "KERJASAMA",
      "value": "PARTNER",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Kode Join (Opsional)\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "tryout_group_kode_join",
      "placeholder": "Maksimal 10 karakter",
      "value": _vm.joinCode = _vm.joinCode.toUpperCase(),
      "maxlength": "10",
      "outlined": ""
    },
    on: {
      "keypress": function($event) {
        / /g.test(
            String.fromCharCode(
              $event.keyCode
            )
          ) ?
          $event.preventDefault() :
          true
      },
      "keyup": function($event) {
        _vm.joinCode = _vm.joinCode.replace(
          / /g,
          ''
        )
      },
      "change": function($event) {
        _vm.joinCode = _vm.joinCode.replace(
          / /g,
          ''
        )
      }
    },
    model: {
      value: (_vm.joinCode),
      callback: function($$v) {
        _vm.joinCode = $$v
      },
      expression: "joinCode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Tanggal Pembahasan Umum *\n                                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_group_tanggal_pembahasan_umum",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "readonly": "",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.discussionDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.discussionDate, "value", $$v)
                },
                expression: "\n                                                                        discussionDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.discussionDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionDate, "option", $$v)
      },
      expression: "\n                                                                discussionDate.option\n                                                            "
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.discussionDate.option = false
      }
    },
    model: {
      value: (
        _vm.discussionDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionDate, "value", $$v)
      },
      expression: "\n                                                                    discussionDate.value\n                                                                "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_group_jam_pembahasan_umum",
                "outlined": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline",
                "readonly": ""
              },
              model: {
                value: (
                  _vm.discussionTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.discussionTime, "value", $$v)
                },
                expression: "\n                                                                        discussionTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.discussionTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionTime, "option", $$v)
      },
      expression: "\n                                                                discussionTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.discussionTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.discussionTime.option = false
      }
    },
    model: {
      value: (
        _vm.discussionTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionTime, "value", $$v)
      },
      expression: "\n                                                                    discussionTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Tanggal Pembahasan Siswa NF\n                                                *\n                                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_group_tanggal_siswa_nf",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "readonly": "",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.discussionSpecialDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.discussionSpecialDate, "value", $$v)
                },
                expression: "\n                                                                        discussionSpecialDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.discussionSpecialDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionSpecialDate, "option", $$v)
      },
      expression: "\n                                                                discussionSpecialDate.option\n                                                            "
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.discussionSpecialDate.option = false
      }
    },
    model: {
      value: (
        _vm.discussionSpecialDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionSpecialDate, "value", $$v)
      },
      expression: "\n                                                                    discussionSpecialDate.value\n                                                                "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_group_jam_siswa_nf",
                "outlined": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline",
                "readonly": ""
              },
              model: {
                value: (
                  _vm.discussionSpecialTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.discussionSpecialTime, "value", $$v)
                },
                expression: "\n                                                                        discussionSpecialTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.discussionSpecialTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionSpecialTime, "option", $$v)
      },
      expression: "\n                                                                discussionSpecialTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.discussionSpecialTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.discussionSpecialTime.option = false
      }
    },
    model: {
      value: (
        _vm.discussionSpecialTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.discussionSpecialTime, "value", $$v)
      },
      expression: "\n                                                                    discussionSpecialTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Waktu Mulai\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "readonly": "",
      "disabled": "",
      "value": _vm.variant ===
        'SCHEDULED' ||
        _vm.variant === 'TPM' ?
        _vm.openedAt :
        '-'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Waktu Selesai\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "disabled": "",
      "readonly": "",
      "value": _vm.variant ===
        'SCHEDULED' ||
        _vm.variant === 'TPM' ?
        _vm.closedAt :
        '-'
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    User Group\n                                ")]), _vm._v(" "), _vm._l((_vm.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i ===
            _vm.user_group.length - 1 &&
            _vm.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "x-large": "",
              "depressed": "",
              "color": "white",
              "elevation": "1"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.user_group.splice(
                    i,
                    1
                  )
              }
            }
          }, [_vm._v("\n                                            Hapus\n                                        ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.user_group, i, $$v)
        },
        expression: "user_group[i]"
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5 mt-8",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                            Tambah User Group Baru\n                        ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.groupId) ? _c('v-card', {
    staticClass: "pa-4 mt-4",
    attrs: {
      "plain": ""
    }
  }, [_c('h6', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v("Tryout")]), _vm._v(" "), _vm._l((_vm.tryouts), function(tryout, index) {
    return _c('v-card', {
      key: index,
      staticClass: "my-3 test_cursor",
      on: {
        "dblclick": function($event) {
          return _vm.editSubtest(index)
        }
      }
    }, [_c('v-list', {
      staticClass: "pa-2 text-subtitle-2"
    }, [
      [_c('v-list-item', {
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "30%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Nama Tryout\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                    " + _vm._s(tryout.name) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "20%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Tipe\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                    " + _vm._s(tryout.type) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "10%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Kategori\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                    " + _vm._s(tryout.category) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start"
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Mata Pelajaran\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, _vm._l((tryout.subtests), function(subtest, index) {
        return _c('span', {
          key: index
        }, [_vm._v("\n                                        " + _vm._s(subtest.subject_name) + ",\n                                    ")])
      }), 0)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "plain": "",
          "id": "tryout_group_hapus_tryout"
        },
        on: {
          "click": function($event) {
            _vm.dialogConfirm.function = tryout;
            _vm.dialogConfirm.title =
              'Apakah anda yakin akan melepas tryout ini?';
            _vm.dialogConfirm.open = true;
          }
        }
      }, [_c('span', {
        staticClass: "red--text",
        class: _vm.$vuetify.breakpoint.mdAndUp ?
          'font-weight-700' :
          'font-weight-600',
        style: (_vm.$vuetify.breakpoint.smAndDown ?
          'font-size: 12px' :
          '')
      }, [_vm._v("Hapus")])])], 1)], 1)]
    ], 2)], 1)
  }), _vm._v(" "), _c('app-tryoutchooser', {
    attrs: {
      "isInstant": _vm.$store.state.tryoutgroup.variant !== 'SCHEDULED' &&
        _vm.$store.state.tryoutgroup.variant !== 'TPM'
    },
    on: {
      "selected": function($event) {
        return _vm.addTryoutIntoGroup($event)
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "pa-4 mt-4"
  }, [_c('v-spacer'), _vm._v(" "), (!_vm.isPublished) ? _c('v-btn', {
    staticClass: "pull-right mx-2 darkYellow--text",
    attrs: {
      "id": "tryout_group_publish",
      "color": "backgroundYellow"
    },
    on: {
      "click": _vm.publishTryoutGroup
    }
  }, [_vm._v("\n                Belum Publish\n            ")]) : _c('v-btn', {
    staticClass: "pull-right mx-2 darkGreen--text",
    attrs: {
      "id": "tryout_group_unpublish",
      "color": "backgroundGreen"
    },
    on: {
      "click": _vm.unPublishTryoutGroup
    }
  }, [_vm._v("\n                Terpublish\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "tryout_group_simpan",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.removeTryoutFromGroup(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67dbc51a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_group/components/Form.vue
// module id = 2111
// module chunks = 1